export type DisplayName = string;

export enum Market {
  Argentina = 'Argentina',
  Australia = 'Australia',
  Belgium = 'Belgium',
  Brazil = 'Brazil',
  Canada = 'Canada',
  Colombia = 'Colombia',
  Finland = 'Finland',
  Germany = 'Germany',
  Italy = 'Italy',
  Mexico = 'Mexico',
  Netherlands = 'Netherlands',
  Norway = 'Norway',
  Poland = 'Poland',
  SouthAfrica = 'South Africa',
  Spain = 'Spain',
  Sweden = 'Sweden',
  Turkey = 'Turkey',
  UnitedArabEmirates = 'United Arab Emirates',
  UnitedKingdom = 'United Kingdom',
  UnitedStates = 'United States',
}

export const allMarkets = Object.values(Market);

export enum Region {
  US = 'US',
  EU = 'EU',
}

export const allRegions: Region[] = [Region.US, Region.EU];
